import styled from 'styled-components';
import React, { cloneElement } from 'react';
import { colors, fontSizes, fontWeights, lineHeights, spacing } from '../../../defaultTheme';
import Button from '../../atoms/Button';
import query from '../../../const/mediaQueries';
// The image is slightly taller than the header, which creates an overflow effect. This is by design.
const BANNER_CARD_IMAGE_HEIGHT = {
    DESKTOP: 240,
    MOBILE: 120
};
const BANNER_CARD_HEADER_HEIGHT = {
    DESKTOP: 219,
    MOBILE: 109
};
export const BannerCardContainer = styled.div `
  width: 100%;
  margin: auto;
  overflow: auto;
  text-align: center;
  // updating card radius to match card header radius, which is the only one changing
  border-radius: ${spacing.base}px ${spacing.base}px 10px 10px;

  @media ${query.greaterThanMedium} {
    max-width: 768px;
  }
`;
export const BannerCardHeader = styled.div `
  background-color: ${(props) => props.$bgColor || colors.syfYellow};
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: ${BANNER_CARD_HEADER_HEIGHT.MOBILE}px;
  margin-top: ${BANNER_CARD_IMAGE_HEIGHT.MOBILE -
    BANNER_CARD_HEADER_HEIGHT.MOBILE}px;
  border-radius: ${spacing.base}px ${spacing.base}px 0 0;

  @media ${query.greaterThanMedium} {
    height: ${BANNER_CARD_HEADER_HEIGHT.DESKTOP}px;
    margin-top: ${BANNER_CARD_IMAGE_HEIGHT.DESKTOP -
    BANNER_CARD_HEADER_HEIGHT.DESKTOP}px;
  }
`;
export const BannerCardImage = styled.img `
  height: ${BANNER_CARD_IMAGE_HEIGHT.MOBILE}px;

  @media ${query.greaterThanMedium} {
    height: ${BANNER_CARD_IMAGE_HEIGHT.DESKTOP}px;
  }
`;
export const BannerCardBody = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.large}px ${spacing.large}px;
  background-color: ${colors.white};
  border-radius: 0 0 10px 10px;

  @media ${query.greaterThanMedium} {
    padding: ${spacing.large}px ${spacing.xxlarge + spacing.base}px;
  }
`;
export const BodyTitle = styled(({ element, className }) => cloneElement(element, { className })) `
  font-size: ${fontSizes.medium}px;
  line-height: ${lineHeights.root};
  font-weight: ${fontWeights.bold};
  margin: 0 0 ${spacing.medium}px;
  color: ${colors.black};

  @media ${query.greaterThanMedium} {
    font-size: ${fontSizes.large}px;
    margin: 0 0 ${spacing.base}px;
  }
`;
const StyledChildren = ({ children, className }) => {
    const isPrimitive = (element) => {
        return (typeof element === 'undefined' ||
            typeof element === 'string' ||
            typeof element === 'number' ||
            typeof element === 'boolean');
    };
    if (isPrimitive(children)) {
        return React.createElement(React.Fragment, null);
    }
    if (Array.isArray(children)) {
        return (React.createElement(React.Fragment, null, children.map((child, key) => {
            if (isPrimitive(child)) {
                return undefined;
            }
            /* eslint-disable-next-line react/no-array-index-key */
            return cloneElement(child, { className, key });
        })));
    }
    return cloneElement(children, { className });
};
export const BodyDescription = styled(StyledChildren) `
  font-size: ${fontSizes.root}px;
  line-height: ${lineHeights.large};
  margin: 0;
  color: ${colors.black};
`;
export const ButtonContainer = styled.div `
  display: grid;
  gap: ${spacing.base}px;
  grid-template-columns: repeat(1, 1fr);
  margin-top: ${spacing.large}px;

  @media ${query.greaterThanMedium} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
export const CenterButton = styled(Button) `
  width: 100%;
  margin: 0;

  @media ${query.greaterThanMedium} {
    max-width: fit-content;
  }
`;
